import { PlusIcon } from '@heroicons/react/24/solid';

export const testId = 'plus-icon-circle';

export function PlusIconCircle(): JSX.Element {
    return (
        <div
            data-testid={testId}
            className='h-5 w-5 border rounded-full p-1 border-gray-500 transition-transform duration-500 ease-in-out'>
            <PlusIcon className='' />
        </div>
    );
}
